(() => {
  const STORAGE_KEY = 'vinit-selected-market';

  /*
   * TASAS MANUALES
   * Moneda base de la tienda: USD
   *
   * Ejemplo:
   * 1 USD = 1.37 CAD
   * 1 USD = 18.50 MXN
   * 1 USD = 0.86 EUR
   */
  const RATES = {
    USD: 1,
    CAD: 1.37,
    MXN: 18.50,
    EUR: 0.86
  };
/*
 * TERMINACIONES COMERCIALES PERMITIDAS
 *
 * No se utiliza .75:
 * cuando el precio se acerca a .75, pasa al próximo .00.
 */
const ROUNDING_RULES = {
  USD: [0, 0.25, 0.50],
  CAD: [0, 0.25, 0.50],
  MXN: [0],
  EUR: [0, 0.50]
};

  const CURRENCY_SETTINGS = {
    USD: {
      locale: 'en-US',
      prefix: '$',
      suffix: ' USD'
    },
    CAD: {
      locale: 'en-CA',
      prefix: 'CA$',
      suffix: ''
    },
    MXN: {
      locale: 'es-MX',
      prefix: 'MX$',
      suffix: ''
    },
    EUR: {
      locale: 'es-ES',
      prefix: '',
      suffix: ' €'
    }
  };

  /*
   * Elementos de precio comunes en el tema Ride.
   * Después de probarlo, podremos añadir cualquier selector que falte.
   */
 const PRICE_SELECTORS = [
  /*
   * Productos y colecciones
   */
  '.price-item--regular',
  '.price-item--sale',
  '.price__regular .price-item',
  '.price__sale .price-item',
  '.card-information .price-item',
  '.product__info-container .price-item',
  '.quick-add-modal__content-info .price-item',

  /*
   * Precio por unidad
   */
  '.unit-price .price-item',
  '.unit-price__price',

  /*
   * Carrito normal
   */
  '.cart-item__old-price',
  '.cart-item__final-price',
  '.cart-item__discounted-prices .price',
  '.cart-item__price-wrapper .price-item',
  '.cart-item__totals .price',
  '.cart__footer .totals__total-value',
  '.cart__blocks .totals__total-value',

  /*
   * Carrito lateral
   */
  'cart-drawer .cart-item__old-price',
  'cart-drawer .cart-item__final-price',
  'cart-drawer .cart-item__discounted-prices .price',
  'cart-drawer .cart-item__price-wrapper .price-item',
  'cart-drawer .cart-item__totals .price',
  'cart-drawer .totals__total-value',
  '.drawer__inner .totals__total-value',

  /*
   * Notificación de producto añadido
   */
  '.cart-notification-product__price',
  '.cart-notification .price-item',

  /*
   * Atributos usados por Shopify
   */
  '[data-cart-item-regular-price]',
  '[data-cart-item-final-price]',
  '[data-cart-subtotal]',
  '[data-cart-total]'
].join(',');

  let currentCurrency = 'USD';
  let conversionScheduled = false;
  let observerPaused = false;

  function getSavedMarket() {
    try {
      const savedValue = localStorage.getItem(STORAGE_KEY);

      if (!savedValue) {
        return null;
      }

      return JSON.parse(savedValue);
    } catch (error) {
      console.warn(
        'Vinit: no se pudo recuperar el mercado guardado.',
        error
      );

      return null;
    }
  }

  function normalizePriceText(text) {
    if (!text) return null;

    /*
     * Elimina símbolos y códigos de moneda.
     * Conserva solamente números, puntos, comas y signo negativo.
     */
    let cleaned = text
      .replace(/\s/g, '')
      .replace(/[^\d.,-]/g, '');

    if (!cleaned || !/\d/.test(cleaned)) {
      return null;
    }

    const lastComma = cleaned.lastIndexOf(',');
    const lastDot = cleaned.lastIndexOf('.');

    /*
     * Si tiene punto y coma, el último separador se considera decimal.
     */
    if (lastComma !== -1 && lastDot !== -1) {
      if (lastComma > lastDot) {
        cleaned = cleaned
          .replace(/\./g, '')
          .replace(',', '.');
      } else {
        cleaned = cleaned.replace(/,/g, '');
      }
    } else if (lastComma !== -1) {
      const decimals = cleaned.length - lastComma - 1;

      if (decimals === 2) {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        cleaned = cleaned.replace(/,/g, '');
      }
    } else if (lastDot !== -1) {
      const decimals = cleaned.length - lastDot - 1;

      if (decimals !== 2) {
        cleaned = cleaned.replace(/\./g, '');
      }
    }

    const value = Number.parseFloat(cleaned);

    return Number.isFinite(value) ? value : null;
  }

function smartRoundPrice(value, currency) {
  const allowedEndings = ROUNDING_RULES[currency];

  if (!allowedEndings || !allowedEndings.length) {
    return Math.round(value * 100) / 100;
  }

  const wholePart = Math.floor(value);
  const candidates = [];

  /*
   * Crea opciones dentro del número actual.
   * Ejemplo: 45.00, 45.25 y 45.50.
   */
  allowedEndings.forEach((ending) => {
    candidates.push(wholePart + ending);
  });

  /*
   * También crea opciones en el número siguiente.
   * Esto permite que 45.78 pueda convertirse en 46.00.
   */
  allowedEndings.forEach((ending) => {
    candidates.push(wholePart + 1 + ending);
  });

  const closestValue = candidates.reduce((closest, candidate) => {
    const candidateDistance = Math.abs(candidate - value);
    const closestDistance = Math.abs(closest - value);

    if (candidateDistance < closestDistance) {
      return candidate;
    }

    /*
     * Cuando dos opciones están a la misma distancia,
     * elegimos la mayor para evitar redondear hacia abajo.
     */
    if (
      candidateDistance === closestDistance &&
      candidate > closest
    ) {
      return candidate;
    }

    return closest;
  });

  return Math.round(closestValue * 100) / 100;
}
  function formatCurrency(value, currency) {
    const settings =
      CURRENCY_SETTINGS[currency] || CURRENCY_SETTINGS.USD;

    const formattedNumber = new Intl.NumberFormat(settings.locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);

    return `${settings.prefix}${formattedNumber}${settings.suffix}`;
  }

  function getOriginalUsdValue(element) {
    /*
     * Guardamos el precio original en USD solo una vez.
     * Esto evita convertir repetidamente un precio ya convertido.
     */
    if (element.dataset.vinitBaseUsd) {
      return Number.parseFloat(element.dataset.vinitBaseUsd);
    }

    const originalValue = normalizePriceText(element.textContent);

    if (originalValue === null) {
      return null;
    }

    element.dataset.vinitBaseUsd = String(originalValue);

    return originalValue;
  }

  function shouldIgnoreElement(element) {
    if (!(element instanceof HTMLElement)) {
      return true;
    }

    if (
      element.closest(
        '.vinit-market-selector, script, style, template, noscript'
      )
    ) {
      return true;
    }

    /*
     * Evita convertir contenedores grandes que contienen varios precios.
     */
    const childPrice = element.querySelector(
      '.price-item, [data-cart-item-final-price]'
    );

    if (childPrice && childPrice !== element) {
      return true;
    }

    return false;
  }

  function convertElement(element, currency) {
    if (shouldIgnoreElement(element)) {
      return;
    }

    const usdValue = getOriginalUsdValue(element);

    if (usdValue === null) {
      return;
    }

    const rate = RATES[currency];

    if (!rate) {
      return;
    }

const convertedValue = usdValue * rate;
const roundedValue = smartRoundPrice(
  convertedValue,
  currency
);

element.textContent = formatCurrency(
  roundedValue,
  currency
);
    element.dataset.vinitDisplayedCurrency = currency;
  }

  function convertVisiblePrices(currency = currentCurrency) {
    if (!RATES[currency]) {
      currency = 'USD';
    }

    currentCurrency = currency;
    observerPaused = true;

    document.querySelectorAll(PRICE_SELECTORS).forEach((element) => {
      convertElement(element, currency);
    });

    window.requestAnimationFrame(() => {
      observerPaused = false;
    });
  }

  function scheduleConversion(currency = currentCurrency) {
    currentCurrency = currency;

    if (conversionScheduled) {
      return;
    }

    conversionScheduled = true;

    window.requestAnimationFrame(() => {
      conversionScheduled = false;
      convertVisiblePrices(currentCurrency);
    });
  }

  function resetChangedPriceNodes(node) {
    if (!(node instanceof HTMLElement)) {
      return;
    }

    /*
     * Shopify puede reemplazar el precio cuando cambia una variante
     * o se actualiza el carrito. Eliminamos el precio base anterior
     * para capturar el nuevo valor enviado por Shopify.
     */
    if (node.matches(PRICE_SELECTORS)) {
      delete node.dataset.vinitBaseUsd;
    }

    node.querySelectorAll(PRICE_SELECTORS).forEach((element) => {
      delete element.dataset.vinitBaseUsd;
    });
  }

  function startMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      if (observerPaused) {
        return;
      }

      let pricesChanged = false;

      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            resetChangedPriceNodes(node);
          });

          pricesChanged = true;
        }

        if (mutation.type === 'characterData') {
          const parent = mutation.target.parentElement;

          if (parent) {
            delete parent.dataset.vinitBaseUsd;
            pricesChanged = true;
          }
        }
      });

      if (pricesChanged) {
        scheduleConversion();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function initializeConverter() {
    const savedMarket = getSavedMarket();

    if (
      savedMarket &&
      savedMarket.currency &&
      RATES[savedMarket.currency]
    ) {
      currentCurrency = savedMarket.currency;
    }

    convertVisiblePrices(currentCurrency);
    startMutationObserver();

    /*
     * Recibe el evento creado por el selector de mercados.
     */
    document.addEventListener('vinit:market-change', (event) => {
      const selectedCurrency = event.detail?.currency;

      if (!selectedCurrency || !RATES[selectedCurrency]) {
        return;
      }

      scheduleConversion(selectedCurrency);
    });

    /*
     * Refuerzos para componentes dinámicos del tema.
     */
    document.addEventListener('shopify:section:load', () => {
      scheduleConversion();
    });

    document.addEventListener('shopify:section:reorder', () => {
      scheduleConversion();
    });

    document.addEventListener('cart:updated', () => {
      scheduleConversion();
    });

    document.addEventListener('variant:change', () => {
      scheduleConversion();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeConverter);
  } else {
    initializeConverter();
  }
})();